import { render, staticRenderFns } from "./PainelChamadosSert.vue?vue&type=template&id=7a5b40a3"
import script from "./PainelChamadosSert.vue?vue&type=script&lang=js"
export * from "./PainelChamadosSert.vue?vue&type=script&lang=js"
import style0 from "./PainelChamadosSert.vue?vue&type=style&index=0&id=7a5b40a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports